import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimplePrintButton from "../../../../modules/SimplePrintButton";
import ErrorAction from "../../../../Redux/ErrorRedux";
import Api from "../../../../Services/Api";
import { fetchDataAsync, getUserAccess } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";
import {
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../../common/mapper";
import ReceivingGiftCreate from "./components/receivingGiftCreate";
import ReceivingGiftFilter from "./components/receivingGiftFilter";
import ReceivingGiftSearch from "./components/receivingGiftSearch";
import {
  formGroupGift,
  INITIAL_FILTER_DATA,
  INITIAL_PAGINATION,
  INITIAL_SEARCH,
  tableConfig,
} from "./config";
import * as R from "ramda";
import { saveAs } from "file-saver";
import ReceivingGiftDetail from "./components/receivingGiftDetail";

class ReceivingGift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userAccess: null,
      loading: false,
      alertSavedModalVisible: false,
      modalCreateDataVisible: false,
      filterModalVisible: false,
      modalDetailVibile: false,
      printModalVisible: false,
      selectedData: null,
      selectedCabang: null,
      fetchingTableData: false,
      search: INITIAL_SEARCH,
      filterData: INITIAL_FILTER_DATA,
      dataCabang: [],
      dataTable: [],
      pagination: INITIAL_PAGINATION,
      alertInfo: {
        visible: false,
        title: null,
        content: null,
        additionalData: null,
      },
      skipNextFetch: false,
    };
  }

  componentDidMount() {
    this.fetchDataCabang();
  }

  componentDidUpdate(prevProps, prevState) {
    const currCabang = this.state.search.kodeCabang?.value;
    const prevCabang = prevState?.search.kodeCabang?.value;
    if (currCabang !== prevCabang) {
      this.handleResetPagination();
      this.setState({
        filterData: INITIAL_FILTER_DATA,
      });
      this.fetchData(
        {
          kodeCabang: currCabang,
          ...INITIAL_SEARCH,
        },
        5,
        1,
      );
    }
  }

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Receiving Gift",
      setError: this.props.setError,
      args: {},
    });
    this.handleTriggerLoading();
    if (res.ok) {
      const filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          ?.map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );
      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
          search: {
            ...prevValue.search,
            kodeCabang: mapToObjectDDL(
              filteredData[0].namaDealer,
              filteredData[0].kodeCabang,
            ),
          },
          userAccess: getUserAccess(
            this.props.menuAccess,
            filteredData[0].kodeCabang,
          ),
        }));
      }
    }
  };

  handleChangePage = async (tableState) => {
    let limit = tableState.rowsPerPage;
    let page = tableState.page + 1;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: page,
        limit: limit,
      },
    }));

    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData),
    );
    const searchRequest = removeNullFields(
      this.parseFilterData(this.state.search),
    );

    let paramFilters;
    if (!R.isEmpty(filterRequest)) {
      paramFilters = {
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
      };
    } else {
      paramFilters = { ...searchRequest };
    }

    await this.fetchData(
      {
        ...paramFilters,
      },
      limit,
      page,
    );
  };

  handleChangeRowsPerPage = async (tableState) => {
    let limit = tableState.rowsPerPage;
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        count: 1,
        page: 1,
        limit: limit,
      },
    }));

    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData),
    );
    const searchRequest = removeNullFields(
      this.parseFilterData(this.state.search),
    );

    let paramFilters;
    if (!R.isEmpty(filterRequest)) {
      paramFilters = {
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
      };
    } else {
      paramFilters = { ...searchRequest };
    }

    await this.fetchData(
      {
        ...paramFilters,
      },
      limit,
      1,
    );
  };

  handleResetPagination = () => {
    this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        limit: 5,
        page: 1,
      },
      search: {
        ...prev.search,
        ...INITIAL_SEARCH,
      },
    }));
  };

  fetchData = async (filter = {}, limit, page) => {
    this.handleTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataMainPageReceivingGit,
      menuName: "Receiving Gift",
      setError: this.props.setError,
      args: {
        ...filter,
        limit,
        page,
      },
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data,
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData,
        },
      }));
    }
  };

  handleTriggerLoading = () => {
    this.setState((prev) => ({ ...prev, loading: !prev.loading }));
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: value,
      },
    }));
  };

  handleClearFilter = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterData: {
        ...prevState.filterData,
        ...this.INITIAL_FILTER_DATA,
      },
    }));
  };

  handleOnSubmitSearch = async () => {
    const { search } = this.state;
    this.setState((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        page: 1,
      },
    }));
    await this.fetchData(
      {
        ...removeNullFields(this.parseFilterData(search)),
      },
      this.state.pagination.limit,
      1,
    );
    this.handleClearFilter();
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
      giftCode: getValueFromDDL(data, "giftCode"),
      giftCategory: getValueFromDDL(data, "giftCategory"),
      kodeLocator: getValueFromDDL(data, "kodeLocator"),
    };
  }

  handleModalFilterVisibility = () => {
    this.setState((prevState) => ({
      ...prevState,
      filterModalVisible: !prevState.filterModalVisible,
    }));
  };

  handleModalDetailVisibility = (data) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedData: data,
      modalDetailVibile: !prevState.modalDetailVibile,
    }));
  };

  getTableConfig = () => {
    return tableConfig({
      handleDetail: this.handleModalDetailVisibility,
    });
  };

  handleModalCreateVisibility = (data) => {
    this.setState((prevState) => ({
      ...prevState,
      selectedData: data,
      modalCreateDataVisible: !prevState.modalCreateDataVisible,
    }));
  };

  handleClearSearch = () => {
    this.setState((prevState) => ({
      ...prevState,
      search: {
        ...prevState.search,
        spbhStartDate: null,
        spbhEndDate: null,
      },
    }));
  };

  handleSubmitFilter = async (filterData) => {
    const { search } = this.state;

    const requestBody = {
      kodeCabang:
        filterData?.kodeCabang?.value || search?.kodeCabang?.value || null,
      spbhNo: filterData?.spbhNo || null,
      spbhStartDate: filterData?.spbhStartDate || null,
      spbhEndDate: filterData?.spbhEndDate || null,
      spbmNo: filterData?.spbmNo || null,
      spbmStartDate: filterData?.spbmStartDate || null,
      spbmEndDate: filterData?.spbmEndDate || null,
      giftCode: filterData?.giftCode?.value || null,
      giftCategory: filterData?.giftCategory?.value || null,
      idLocator: filterData?.idLocator?.value || null,
    };

    this.setState((prev) => ({
      ...prev,
      search: {
        ...prev.search,
        spbhStartDate: null,
        spbhEndDate: null,
      },
      filterData: requestBody,
    }));
    await this.fetchData(removeNullFields(requestBody), this.state.pagination.limit, 1);
    this.handleModalFilterVisibility();
  };

  handleAlertInfo = (title, content, additionalData, action) => {
    this.setState((prev) => ({
      ...prev,
      alertInfo: {
        ...prev.alertInfo,
        visible: !prev.alertInfo.visible,
        title: title,
        content: content,
        additionalData: additionalData,
        action: action,
      },
    }));
  };

  handleSubmit = async (payload, action) => {
    this.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").submitReceivingGift,
      menuName: "Receiving Gift",
      setError: this.props.setError,
      args: payload,
    });
    this.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.handleAlertInfo();
      if (action === "save") {
        this.handleModalCreateVisibility();
      } else {
        this.handleModalDetailVisibility();
      }
      // this.handleResetPagination();
      // this.fetchData(
      //   {
      //     kodeCabang: this.state.search.kodeCabang?.value,
      //     ...INITIAL_SEARCH,
      //   },
      //   5,
      //   1,
      // );
      await this.handleRefetchAfterProcess()
      this.handleAlertInfo("Informasi", "Data Telah Disimpan");
    }
  };

  handlePrint = async () => {
    this.handleTriggerLoading();
    const { filterData, search } = this.state;
    const requestBody = {
      ...filterData,
      kodeCabang: search.kodeCabang?.value,
      spbhStartDate: search.spbhStartDate || filterData.spbhStartDate,
      spbhEndDate: search.spbhEndDate || filterData.spbhEndDate,
      limit: null,
      page: null,
    };

    try {
      const res = await Api.create(
        "NAGAMAS_TRANSACTION_FILE",
      ).downloadReceivingGiftExcel(requestBody);
      if (res.ok) {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "RECEIVING_GIFT.xlsx");
      }
    } catch (error) {
      console.log(error);
    }
    this.handleTriggerLoading();
  };

  handleOnDelete = async (id) => {
      this.handleTriggerLoading();
      await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").deleteReceivingGift,
        menuName: "Receiving Gift",
        setError: this.props.setError,
        args: {
          spbhNo: id,
        },
      });
      this.handleTriggerLoading();
      this.handleAlertInfo();
      // this.handleResetPagination();
      // this.fetchData(
      //   {
      //     kodeCabang: this.state.search.kodeCabang?.value,
      //     ...INITIAL_SEARCH,
      //   },
      //   5,
      //   1,
      // );
      await this.handleRefetchAfterProcess()
      this.handleAlertInfo("Informasi", "Data telah dihapus");
      this.handleModalDetailVisibility();
  };

  handleConfirmAlertInfo = () => {
    const { alertInfo } = this.state;
    if (alertInfo.action === "update") {
      this.handleSubmit(alertInfo.additionalData, "update");
    }
    if (alertInfo.action === "delete") {
      this.handleOnDelete(alertInfo.additionalData);
    }
  };

  handleRefetchAfterProcess = async () => {
    this.handleTriggerLoading()
    const filterRequest = removeNullFields(
      this.parseFilterData(this.state.filterData),
    );
    const searchRequest = removeNullFields(
      this.parseFilterData(this.state.search),
    );

    let paramFilters;
    if (!R.isEmpty(filterRequest)) {
      paramFilters = {
        ...filterRequest,
        kodeCabang: this.state.search.kodeCabang.value,
      };
    } else {
      paramFilters = { ...searchRequest };
    }

    await this.fetchData(
      {
        ...paramFilters,
      },
      this.state.pagination.limit,
      this.state.pagination.page,
    );
    this.handleTriggerLoading()
  };

  render() {
    const {
      loading,
      dataCabang,
      search,
      dataTable,
      pagination,
      modalCreateDataVisible,
      userAccess,
      filterModalVisible,
      filterData,
      alertInfo,
      selectedData,
      modalDetailVibile,
    } = this.state;
    return (
      <React.Fragment>
        <ReceivingGiftSearch
          dataCabang={dataCabang}
          searchValue={search}
          onSearchChange={this.handleSearchValueChange}
          onSubmit={this.handleOnSubmitSearch}
          onFilterClick={this.handleModalFilterVisibility}
        />
        <SimpleDataTable
          key={`${pagination.totalData}-${pagination.page}`}
          columns={this.getTableConfig()}
          data={dataTable}
          options={defaultTableChange(
            (tableState) => this.handleChangePage(tableState),
            (tableState) => this.handleChangeRowsPerPage(tableState),
          )}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          footerAdditionalButtons={
            <FlexView hAlignContent={"right"}>
              {userAccess && userAccess.createAccess && (
                <SimpleButton
                  onClick={this.handleModalCreateVisibility}
                  icon={<i className="fa fa-plus margin-right-10px"></i>}
                  text={"Tambah Data"}
                />
              )}
              <SimplePrintButton
                text="Cetak"
                toExcel
                onPrint={(value) => this.handlePrint(value)}
              />
            </FlexView>
          }
        />
        {alertInfo.visible && (
          <SimpleAlert
            title={alertInfo.title}
            content={alertInfo.content}
            visible={alertInfo.visible}
            onClickClose={this.handleAlertInfo}
            additionalButtons={
              alertInfo.additionalData ? (
                <FlexView style={{ gap: "15px" }}>
                  <SimpleButton
                    className="margin-left-none"
                    type="button"
                    text="Batal"
                    onClick={() => this.handleAlertInfo()}
                  />
                  <SimpleButton
                    className="margin-left-none"
                    type="button"
                    text="Iya"
                    onClick={() => this.handleConfirmAlertInfo()}
                  />
                </FlexView>
              ) : (
                <SimpleButton
                  type="button"
                  text="OK"
                  onClick={() => this.handleAlertInfo()}
                />
              )
            }
          />
        )}
        {modalCreateDataVisible && (
          <ReceivingGiftCreate
            {...this.props}
            formGroup={formGroupGift}
            selectedCabang={search.kodeCabang}
            visible={modalCreateDataVisible}
            userAccess={userAccess}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleModalCreateVisibility}
            onChangeAlertInfo={this.handleAlertInfo}
            onSubmit={this.handleSubmit}
          />
        )}
        {modalDetailVibile && (
          <ReceivingGiftDetail
            {...this.props}
            initialValues={selectedData}
            formGroup={formGroupGift}
            selectedCabang={search.kodeCabang}
            visible={modalDetailVibile}
            userAccess={userAccess}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleModalDetailVisibility}
            onChangeAlertInfo={this.handleAlertInfo}
            onSubmit={this.handleSubmit}
          />
        )}
        {filterModalVisible && (
          <ReceivingGiftFilter
            {...this.props}
            selectedCabang={search.kodeCabang}
            filteredData={filterData}
            visible={filterModalVisible}
            onSubmit={this.handleSubmitFilter}
            onTriggerLoading={this.handleTriggerLoading}
            onClickClose={this.handleModalFilterVisibility}
          />
        )}
        {loading && <SimpleLoadingOverlay active={loading} />}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(ReceivingGift);
